module.exports = __webpack_public_path__ + "ba9de1b27d3d25631ad3c37449e0e3d3.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-directory-label/sp-directory-label.html
// module id = 1096
// module chunks = 0